import PropTypes from "prop-types";
import * as types from "../../constants/ComponentConstants";

import statusSVG from "./svg/StatusIcon";
import statusOrganisator from "./svg/StatusOrganisator";
import statusVeldtoertocht from "./svg/StatusVeldtoertocht";
import statusCycloTocht from "./svg/StatusCycloTocht";
import statusPublicatie from "./svg/StatusPublicatie";
import statusLussen from "./svg/StatusLussen";
import statusAfstanden from "./svg/StatusAfstanden";
import statusToelatingen from "./svg/StatusToelatingen";
import statusSamenvatting from "./svg/StatusSamenvatting";
import statusTerugNaarOverzicht from "./svg/StatusTerugNaarOverzicht";

const TabNavIcon = (props) => {

    const { type, color } = props;

    let svgcontent = {
        [types.ICON_STATUS]: statusSVG,
        [types.ICON_ORGANISATOR]: statusOrganisator,
        [types.ICON_VELDTOERTOCHT]: statusVeldtoertocht,
        [types.ICON_CYCLOTOCHT]: statusCycloTocht,
        [types.ICON_PUBLICATIE]: statusPublicatie,
        [types.ICON_LUSSEN]: statusLussen,
        [types.ICON_AFSTANDEN]: statusAfstanden,
        [types.ICON_TOELATINGEN]: statusToelatingen,
        [types.ICON_SAMENVATTING]: statusSamenvatting,
        [types.ICON_TERUGNAAROVERZICHT]: statusTerugNaarOverzicht
    };

    let svgpaths = svgcontent[types.ICON_STATUS];
    if (type) {
        svgpaths = svgcontent[type] || svgcontent[types.ICON_STATUS];
    }

    return (svgpaths(color));
};

TabNavIcon.propTypes = {
    type: PropTypes.string,
    color: PropTypes.string
};

export default TabNavIcon;